"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("react");
const b_1 = __importDefault(require("b_"));
const selector_1 = require("src/utils/selector");
const b = b_1.default.with('geo');
function GeoSuggestions({ suggestItems, itemIndex, handleSuggestionClick, clearSuggestions }) {
    const listRef = (0, react_1.useRef)(null);
    const itemRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (itemIndex >= 0 && itemRefs.current[itemIndex]) {
            (_a = itemRefs.current[itemIndex]) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
        }
    }, [itemIndex]);
    if (suggestItems.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('suggest-container') }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('suggest'), ref: listRef }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('suggest-wrapper'), role: 'listbox', id: 'listbox', tabIndex: -1 }, { children: suggestItems.map(({ label }, index) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: el => (itemRefs.current[index] = el), className: b('item', { withFocus: index === itemIndex }), "data-value": label, "data-title": label, onClick: () => handleSuggestionClick(label), role: 'option', "aria-selected": index === itemIndex, id: (0, selector_1.getElementIdSelector)('suggestion', { id: index }) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('item-text') }, { children: label })) }), `${label}-${index}`))) })) })), (0, jsx_runtime_1.jsx)("div", { className: b('suggest-cover'), onClick: clearSuggestions })] })));
}
exports.default = GeoSuggestions;
